import React from 'react';
import { WebsiteLayout } from '@components/common/layout';
import { Home } from '@components/screens';
import Head from 'next/head';

function PageWithLayout({ user, logout, onAuthSuccess = () => {} }) {
  return (
    <>
<Head>
{/* <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `
                _linkedin_partner_id = "8542297";
                window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                window._linkedin_data_partner_ids.push(_linkedin_partner_id);
              `,
            }}
          />
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `
                (function() {
                  var s = document.getElementsByTagName("script")[0];
                  var b = document.createElement("script");
                  b.type = "text/javascript"; b.async = true;
                  b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                  s.parentNode.insertBefore(b, s);
                })();
              `,
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: `
                <noscript>
                  <img height="1" width="1" style="display:none;" alt=""
                  src="https://px.ads.linkedin.com/collect/?pid=8542297&fmt=gif" />
                </noscript>
              `,
            }}
          /> */}
</Head>
    <WebsiteLayout user={user} handleLogout={logout}>
      <Home />
    </WebsiteLayout>

    </>
  );
}

export default PageWithLayout;
